import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import type { ImportCommitResult } from '@/api/clientImports/clientImportsApi.types';
import { APPLICATION_ROUTES } from '@/constants/applicationRoutes';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Icon } from '@/components/common/Icon';

interface ImportResultPanelProps {
  result: ImportCommitResult;
  onImportAnother: () => void;
}

export function ImportResultPanel({ result, onImportAnother }: ImportResultPanelProps) {
  const { t } = useTranslation('clientImport');
  const navigate = useNavigate();

  return (
    <Card padding="lg" className="max-w-xl mx-auto text-center">
      <div className="w-14 h-14 rounded-full bg-zoosuccessbg text-zoosuccesstext flex items-center justify-center mx-auto">
        <Icon name="CheckCircle" className="w-7 h-7" />
      </div>
      <h2 className="text-lg font-bold text-zooindigo mt-4">{t('result.title')}</h2>
      <ul className="mt-4 flex flex-col gap-1.5 text-sm text-zoomuted">
        <li>{t('result.createdClients', { count: result.createdClientCount })}</li>
        <li>{t('result.attachedClients', { count: result.attachedExistingClientCount })}</li>
        <li>{t('result.createdPets', { count: result.createdPetCount })}</li>
      </ul>
      <div className="mt-6 flex items-center justify-center gap-3">
        <Button variant="outline" onClick={onImportAnother}>
          {t('result.importAnother')}
        </Button>
        <Button
          onClick={function goToClients() {
            navigate(APPLICATION_ROUTES.workspaceClients);
          }}
        >
          {t('result.backToClients')}
        </Button>
      </div>
    </Card>
  );
}
